export const de = {
  // Navigation
  nav: {
    home: 'Startseite',
    traveler: 'Reiseerlebnis',
    partner: 'Partner-Erfolg',
    vienna: 'Wien Entdecken',
    host: 'Gastgeber-Programm',
    signup: 'Partner-Anmeldung',
  },
  
  // Common UI Elements
  common: {
    cta: {
      signupNow: 'Jetzt starten',
      becomePartner: 'Partner werden',
      downloadApp: 'App herunterladen',
      learnMore: 'Mehr erfahren',
      getStarted: 'Jetzt beginnen',
      contactUs: 'Kontaktiere uns',
      applyNow: 'Jetzt bewerben',
      exploreVienna: 'Wien erkunden',
      startExploring: 'Beginne die Erkundung',
      viewDashboard: 'Dashboard ansehen',
      readMore: 'Mehr lesen',
    },
    loading: 'Lädt...',
    loadingText: 'Lädt {page}...',
    error: 'Ein Fehler ist aufgetreten',
    submit: 'Absenden',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    view: 'Ansehen',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    search: 'Suchen',
    filter: 'Filter',
    sort: 'Sortieren nach',
    noResults: 'Keine Ergebnisse gefunden',
    trustedBy: 'Vertraut von {value}+ {entity}',
    freeUntil: 'KOSTENLOS',
    untilEndOfYear: 'Bis Jahresende',
  },
  
  // Metadata/SEO
  metadata: {
    home: {
      title: 'TravelHeroes - Entdecke Wien mit lokalen Helden',
      description: 'Exklusive Erlebnisse und authentische Ersparnisse in Wien. Verbinde dich mit lokalen Experten und erlebe Wien wie ein Einheimischer.',
    },
    partnerSuccess: {
      title: 'Partner-Erfolgszentrum - TravelHeroes',
      description: 'Werde Teil von Wiens führender Tourismus-Plattform. Erreiche qualifizierte Touristen, steigere deinen Umsatz und wachse mit null Vorabkosten. Umfassender Business Case mit ROI-Rechnern, Dashboard-Vorschauen und Wachstums-Testimonials.',
    },
    partnerSignup: {
      title: 'Partner-Anmeldung - TravelHeroes',
      description: 'Melde dich jetzt an und werde TravelHeroes Partner. Erreiche tausende Touristen in Wien und steigere deinen Umsatz.',
    },
    travelers: {
      title: 'Reiseerlebnis - TravelHeroes',
      description: 'Deine Reise, dein Weg. Entdecke authentische Erlebnisse in Wien, kuratiert von einheimischen Experten.',
    },
    vienna: {
      title: 'Wien Entdecken - TravelHeroes',
      description: 'Erkunde das Herz Europas. Von imperialen Palästen bis zu modernen Kunstszenen - Wien erwartet dich mit unvergesslichen Erlebnissen.',
    },
    hosts: {
      title: 'Gastgeber-Programm - TravelHeroes',
      description: 'Werde ein lokaler Held. Teile deine Stadt mit Reisenden und verdiene Geld, während du Touristen deine Lieblingsplätze zeigst.',
    },
  },
  
  // Homepage
  home: {
    hero: {
      headline: 'Entdecke Wien wie ein lokaler Held',
      subtitle: 'Exklusive Erlebnisse, authentische Ersparnisse, unvergessliche Erinnerungen',
      travelerTab: 'Reisende',
      partnerTab: 'Partner',
      travelerTitle: 'Entdecke Wien wie ein lokaler Held',
      travelerSubtitle: 'Exklusive Erlebnisse, authentische Ersparnisse, unvergessliche Erinnerungen',
      partnerTitle: 'Mehr Touristen für dein Geschäft',
      partnerSubtitle: 'Kosteneffektives Marketing mit messbarem ROI und echten Ergebnissen',
    },
    stats: {
      tourists: 'Touristen/Jahr',
      touristsAnnual: '{value}+ Touristen jährlich',
      rooms: '{value}+ Hotelzimmer',
      roomsApartments: '{value}+ Hotelzimmer & Apartments',
      nights: '{value}+ Übernachtungen',
      nightsSpent: '{value}+ Übernachtungen in Wien',
      travelers: 'Glückliche Reisende',
      partners: '{value}+ Partner',
      offers: '{value}+ Angebote',
      rating: '{value} Durchschnittliche Bewertung',
      ratingText: 'Von {value}+ Nutzern als ausgezeichnet bewertet',
    },
    features: {
      title: 'Warum TravelHeroes wählen',
      subtitle: 'Erlebe Reisen neu gedacht',
      items: [
        {
          title: 'Lokale Expertise',
          description: 'Verbinde dich mit einheimischen Experten, die ihre Stadt in- und auswendig kennen',
        },
        {
          title: 'Exklusive Angebote',
          description: 'Erhalte Zugang zu speziellen Rabatten und Deals, die nur für unsere Community verfügbar sind',
        },
        {
          title: 'Authentische Erlebnisse',
          description: 'Entdecke versteckte Perlen und erlebe Reiseziele wie ein Einheimischer',
        },
      ],
    },
    testimonials: {
      title: 'Was unsere Reisenden sagen',
      subtitle: 'Echte Geschichten von echten Abenteurern',
    },
    cta: {
      title: 'Bereit für dein Abenteuer?',
      subtitle: 'Schließe dich Tausenden von Reisenden an, die authentische Erlebnisse entdecken',
    },
  },
  
  // Partner Success Center
  partnerSuccess: {
    hero: {
      headline: 'Verwandle Touristen in deine besten Kunden',
      subtitle: 'Wachse mit TravelHeroes',
      description: 'Werde Teil von Wiens führender Plattform, die lokale Geschäfte mit erlebnishungrigen Reisenden verbindet. Steigere Kundenfrequenz, erhöhe Umsatz und baue langfristige Kundenbeziehungen auf.',
      trustedBy: 'Vertraut von {value}+ Wiener Unternehmen',
      badgeText: 'Vertraut von {value}+ Wiener Unternehmen',
    },
    howItWorks: {
      title: 'So funktioniert es',
      subtitle: 'Dein Geschäft, deine Regeln – vollständige Flexibilität bei der Interaktion mit Reisenden',
      requirementTitle: 'Partner müssen Reisenden einen Mehrwert bieten',
      requirementDescription: 'Um TravelHeroes beizutreten, müssen Partner unseren Reisenden eine Form von Vorteil oder Rabatt anbieten. Dies könnte sein:',
      options: [
        {
          title: 'Prozentrabatt',
          example: '10% auf die Gesamtrechnung'
        },
        {
          title: 'Fester Betrag',
          example: '€5 Rabatt auf den Einkauf'
        },
        {
          title: 'Gratis Goodie',
          example: 'Kostenloses Dessert oder Getränk'
        },
        {
          title: 'Deine kreative Idee',
          example: 'Jeder Vorteil, den du dir vorstellen kannst!'
        }
      ],
      flexibilityTitle: 'Vollständige Flexibilität – Du entscheidest',
      flexibilityDescription: 'Im Gegensatz zu anderen Plattformen, die strenge Bedingungen vorschreiben, gibt dir TravelHeroes die vollständige Kontrolle. Du wählst, was am besten für dein Geschäft und deine Kunden funktioniert. Wir sagen dir nicht, was du tun sollst – wir verbinden dich einfach mit Reisenden, die nach authentischen Wien-Erlebnissen suchen.',
      footerText: 'Deine Kreativität = Dein Erfolg.',
      footerHighlight: 'Gestalte ein Angebot, das für dein Geschäft sinnvoll ist und gleichzeitig Reisende begeistert.'
    },
    benefits: {
      title: 'Warum Wiener Unternehmen TravelHeroes wählen',
      subtitle: 'Alles, was du brauchst, um Touristenverkehr in treue Kunden zu verwandeln',
      items: [
        {
          title: 'KEINE KOSTEN bis 31. Dezember 2026',
          description: 'Tritt jetzt bei mit absolut null Gebühren, keine Einrichtungskosten und keine Provisionen bis Ende 2026. Beginne risikolos, dein Geschäft zu erweitern.',
          highlight: 'Null finanzielle Verpflichtung bis 31. Dezember 2026'
        },
        {
          title: 'Qualitativ hochwertiger Touristenverkehr',
          description: 'Verbinde dich mit engagierten Reisenden, die aktiv nach authentischen Wien-Erlebnissen suchen. Unsere Plattform bringt vorqualifizierte Touristen direkt zu deinem Geschäft.',
          highlight: 'Erreiche erlebnissuchende Reisende, keine Schnäppchenjäger'
        },
        {
          title: 'Echtzeit-Analyse-Dashboard',
          description: 'Verfolge deine Leistung mit umfassenden Analysen. Überwache Buchungen, Umsatz und Kundenengagement alles in einem leistungsstarken Dashboard.',
          highlight: 'Treffe datengestützte Entscheidungen zur Optimierung deiner Angebote'
        },
        {
          title: 'Vollständige Flexibilität',
          description: 'Volle Kontrolle über deine Angebote, Verfügbarkeit und Preisgestaltung. Aktualisiere deine Einträge sofort und verwalte alles nach deinem Zeitplan.',
          highlight: 'Aktualisiere Angebote in Echtzeit von jedem Gerät'
        },
        {
          title: 'Mobile-First-Plattform',
          description: 'Erreiche Touristen dort, wo sie sind, mit unserer hoch bewerteten mobilen App, die Reisende während ihrer gesamten Wien-Reise nutzen.',
          highlight: 'Professionelle Präsenz ohne Marketing-Aufwand'
        },
        {
          title: 'Integrierte Verifizierung',
          description: 'Sicheres QR-Code-Validierungssystem stellt sicher, dass nur legitime Einlösungen erfolgen. Schütze dein Geschäft vor Coupon-Missbrauch.',
          highlight: 'Betrugssicherheit und sichere Transaktionen'
        }
      ],
      tourismTitle: 'Nutze Wiens Tourismusmarkt',
      tourismSubtitle: 'Tritt der Plattform bei, die Unternehmen mit Wiens florierendem Tourismus-Ökosystem verbindet',
      tourismStats: {
        tourists: '400.000+',
        touristsLabel: 'Einzelne Touristen pro Jahr',
        rooms: '600+',
        roomsLabel: 'Hotelzimmer & Apartments',
        nights: '900.000+',
        nightsLabel: 'Übernachtungen'
      }
    },
    comparison: {
      badge: 'Direkter Vergleich',
      title: 'TravelHeroes vs. Traditionelles Marketing',
      subtitle: 'Sieh, warum kluge Wiener Unternehmen wechseln',
      tableHeaders: {
        feature: 'Merkmal',
        traditional: 'Traditionelle Plattformen',
        travelheroes: 'TravelHeroes'
      },
      items: [
        {
          feature: 'Einrichtungskosten',
          traditional: '€500-2.000',
          travelheroes: '€0'
        },
        {
          feature: 'Monatliche Gebühr',
          traditional: '€50-200',
          travelheroes: '€0 (bis Ende 2024)'
        },
        {
          feature: 'Provisionssatz',
          traditional: '20-30%',
          travelheroes: '0% (bis Ende 2024)'
        },
        {
          feature: 'Zielgruppe',
          traditional: 'Generische Touristen',
          travelheroes: 'Erlebnissuchende'
        },
        {
          feature: 'Analyse-Dashboard',
          traditional: 'Grundlegende Berichte',
          travelheroes: 'Echtzeit-Einblicke'
        },
        {
          feature: 'Angebotsflexibilität',
          traditional: 'Begrenzte Änderungen',
          travelheroes: 'Unbegrenzte Updates'
        },
        {
          feature: 'Kundenqualität',
          traditional: 'Preisfokussiert',
          travelheroes: 'Wertfokussiert'
        },
        {
          feature: 'Support',
          traditional: 'Nur E-Mail',
          travelheroes: 'Dedizierter Manager'
        }
      ],
      advantageTitle: 'Der TravelHeroes-Vorteil',
      advantageDescription: 'Spare bei Marketingkosten und erreiche gleichzeitig hochwertigere Touristen, die authentische Erlebnisse schätzen. Keine Verträge, keine Verpflichtungen - nur Ergebnisse. Starte risikofrei mit null Kosten bis Jahresende.',
      ctaButton: 'Jetzt anmelden',
      ctaFooter: 'Keine Kreditkarte erforderlich • Jederzeit kündbar • Voller Support inklusive'
    },
    faq: {
      badge: 'Partner-Support',
      title: 'Häufig gestellte Fragen',
      subtitle: 'Alles, was du über die Partnerschaft mit TravelHeroes wissen musst',
      items: [
        {
          category: 'Preisgestaltung',
          question: 'Was sind die Kosten für den Beitritt zu TravelHeroes?',
          answer: 'Es gibt keine Vorabkosten oder monatlichen Gebühren. Wir berechnen nur eine Provision von 15% auf abgeschlossene Transaktionen, wenn Touristen deine Angebote einlösen. Du zahlst nur, wenn du Ergebnisse erzielst.'
        },
        {
          category: 'Preisgestaltung',
          question: 'Wie funktioniert die Provisionsstruktur?',
          answer: 'Unsere 15% Provision wird automatisch von jeder Transaktion abgezogen. Wenn beispielsweise ein Tourist ein €20-Angebot einlöst, erhältst du €17. Alle Zahlungen werden wöchentlich per Banküberweisung abgewickelt.'
        },
        {
          category: 'Erste Schritte',
          question: 'Wie lange dauert der Genehmigungsprozess?',
          answer: 'Die meisten Anträge werden innerhalb von 24-48 Stunden geprüft. Nach der Genehmigung kannst du sofort dein Profil einrichten und Angebote erstellen. Dein Geschäft kann innerhalb von 3 Tagen auf der Plattform live sein.'
        },
        {
          category: 'Erste Schritte',
          question: 'Welche Arten von Unternehmen können beitreten?',
          answer: 'Wir begrüßen Restaurants, Cafés, Attraktionen, Museen, Einzelhandelsgeschäfte, Reiseveranstalter und jedes Wiener Unternehmen, das Erlebnisse oder Dienstleistungen anbietet, die Touristen genießen würden. Jede Bewerbung wird individuell geprüft.'
        },
        {
          category: 'Betrieb',
          question: 'Wie lösen Touristen Angebote ein?',
          answer: 'Touristen zeigen einen einzigartigen QR-Code aus der TravelHeroes-App an deinem Standort. Du scannst ihn mit unserer Partner-App oder dem Web-Dashboard, um die Einlösung zu verifizieren und abzuschließen. Der Vorgang dauert weniger als 10 Sekunden.'
        },
        {
          category: 'Betrieb',
          question: 'Kann ich meine Angebote ändern oder pausieren?',
          answer: 'Ja, du hast die vollständige Kontrolle. Aktualisiere Angebotsdetails, passe die Verfügbarkeit an oder pausiere Angebote jederzeit über dein Dashboard. Änderungen werden sofort wirksam ohne Genehmigungsverzögerungen.'
        },
        {
          category: 'Support',
          question: 'Welche Art von Support erhalten Partner?',
          answer: 'Jeder Partner erhält einen dedizierten Account Manager, 24/7 technischen Support, Marketingmaterialien und Zugang zu unserem Partner-Community-Forum. Wir bieten auch monatliche Webinare zu Tourismustrends und Optimierungsstrategien an.'
        },
        {
          category: 'Support',
          question: 'Gibt es einen Vertrag oder eine Mindestverpflichtung?',
          answer: 'Keine Verträge oder langfristigen Verpflichtungen erforderlich. Du kannst deine Partnerschaft jederzeit ohne Strafen pausieren oder beenden. Wir glauben daran, dein Geschäft durch Ergebnisse zu verdienen, nicht durch bindende Vereinbarungen.'
        }
      ],
      stillQuestionsTitle: 'Noch Fragen?',
      stillQuestionsDescription: 'Unser Partner-Erfolgsteam ist hier, um zu helfen. Schreiben Sie uns eine E-Mail, um zu besprechen, wie TravelHeroes für Ihre spezifischen Geschäftsanforderungen funktionieren kann.',
      consultationButton: 'Beratung vereinbaren',
      emailButton: 'E-Mail-Support'
    },
    cta: {
      title: 'Bereit, dein Geschäft zu erweitern?',
      subtitle: 'Tritt Wiens führender Tourismus-Plattform bei und beginne noch heute, qualitativ hochwertige Touristen anzuziehen.',
      button: 'Jetzt anmelden'
    },
    sections: {
      benefits: 'Vorteile',
      roi: 'ROI-Rechner',
      dashboard: 'Dashboard-Vorschau',
      comparison: 'Marktvergleich',
      stories: 'Erfolgsgeschichten',
    },
  },
  
  // Partner Signup
  partnerSignup: {
    hero: {
      headline: 'Werde TravelHeroes Partner',
      subtitle: 'Erreiche tausende Touristen und steigere deinen Umsatz',
    },
    form: {
      title: 'Partner-Anmeldeformular',
      description: 'Fülle das Formular aus und wir melden uns bei dir',
      businessName: 'Geschäftsname',
      contactPerson: 'Ansprechpartner',
      email: 'E-Mail',
      phone: 'Telefon',
      businessType: 'Art des Geschäfts',
      message: 'Nachricht (optional)',
      submit: 'Jetzt Partner werden',
      embedUrl: 'https://docs.google.com/forms/d/e/YOUR_GERMAN_FORM_ID/viewform?embedded=true',
    },
  },
  
  // Traveler Experience
  travelers: {
    hero: {
      headline: 'Deine Reise, dein Weg',
      subtitle: 'Authentische Erlebnisse, kuratiert von Einheimischen',
    },
    features: {
      title: 'App-Funktionen',
      subtitle: 'Alles, was du für die perfekte Reise brauchst',
      items: [
        {
          title: 'Exklusive Deals',
          description: 'Spare bis zu 40% bei Attraktionen, Restaurants und Hotels',
        },
        {
          title: 'Live-Verfügbarkeit',
          description: 'Echtzeit-Updates zu Angeboten und freien Plätzen',
        },
        {
          title: 'Insider-Tipps',
          description: 'Entdecke Geheimtipps von echten Wienern',
        },
      ],
    },
    offers: {
      title: 'Live-Angebote',
      subtitle: 'Exklusive Deals nur für dich',
      upTo: 'Bis zu',
      discount: '{value}% Rabatt',
    },
    testimonials: {
      title: 'Reisegeschichten',
      subtitle: 'Höre von unserer Community',
    },
    download: {
      title: 'Lade die App herunter',
      subtitle: 'Beginne dein Abenteuer noch heute',
      description: 'Verfügbar auf iOS und Android',
    },
  },
  
  // Vienna Discovery
  vienna: {
    hero: {
      headline: 'Entdecke Wien',
      subtitle: 'Erkunde das Herz Europas',
      description: 'Von imperialen Palästen bis zu modernen Kunstszenen - Wien erwartet dich',
    },
    stats: {
      title: 'Wien auf einen Blick',
      population: '{value}M Einwohner',
      districts: '{value} Bezirke',
      palaces: '{value}+ Schlösser',
      coffeehouses: '{value}+ Kaffeehäuser',
    },
    districts: {
      title: 'Bezirke erkunden',
      subtitle: 'Jeder mit einzigartigem Charakter',
    },
    hiddenGems: {
      title: 'Geheimtipps',
      subtitle: 'Orte, die Einheimische lieben',
    },
    experiences: {
      title: 'Wiener Erlebnisse',
      subtitle: 'Unvergessliche Momente',
    },
    quiz: {
      title: 'Wien-Entdeckungs-Quiz',
      subtitle: 'Teste dein Wissen über die Stadt',
      start: 'Quiz starten',
    },
    cultural: {
      title: 'Kulturelle Zeitreise',
      subtitle: 'Von der Kaiserzeit bis heute',
    },
  },
  
  // Host Program
  hosts: {
    hero: {
      headline: 'Werde ein lokaler Held',
      subtitle: 'Teile deine Stadt mit Reisenden',
      description: 'Verdiene Geld, während du Touristen deine Lieblingsplätze zeigst',
    },
    types: {
      title: 'Arten von Gastgebern',
      subtitle: 'Finde deine Rolle',
      items: [
        {
          title: 'Erlebnis-Gastgeber',
          description: 'Führe einzigartige Touren und Aktivitäten durch',
        },
        {
          title: 'Kultur-Botschafter',
          description: 'Teile Wiens Geschichte und Traditionen',
        },
        {
          title: 'Kulinarik-Experte',
          description: 'Zeige die besten kulinarischen Spots der Stadt',
        },
      ],
    },
    benefits: {
      title: 'Gastgeber-Vorteile',
      subtitle: 'Warum Gastgeber werden',
      items: [
        {
          title: 'Flexible Zeiten',
          description: 'Arbeite wann und wie oft du möchtest',
        },
        {
          title: 'Faire Vergütung',
          description: 'Verdiene {value}-{max}€ pro Tour',
        },
        {
          title: 'Kostenlose Schulung',
          description: 'Wir bereiten dich optimal vor',
        },
      ],
    },
    howItWorks: {
      title: 'So geht\'s los',
      subtitle: 'Einfacher Einstieg in 4 Schritten',
      steps: [
        {
          title: 'Bewerbung',
          description: 'Fülle das kurze Bewerbungsformular aus',
        },
        {
          title: 'Schulung',
          description: 'Nimm an unserem kostenlosen Training teil',
        },
        {
          title: 'Profil erstellen',
          description: 'Gestalte dein Gastgeber-Profil',
        },
        {
          title: 'Loslegen',
          description: 'Empfange deine ersten Gäste',
        },
      ],
    },
    community: {
      title: 'Trete unserer Community bei',
      subtitle: 'Verbinde dich mit anderen Gastgebern',
      members: '{value}+ aktive Gastgeber',
    },
    faq: {
      title: 'Gastgeber-FAQs',
      subtitle: 'Häufige Fragen beantwortet',
      items: [
        {
          question: 'Brauche ich Vorkenntnisse?',
          answer: 'Nein! Wir schulen dich in allem, was du wissen musst. Du brauchst nur Leidenschaft für Wien.',
        },
        {
          question: 'Wie viel kann ich verdienen?',
          answer: 'Durchschnittlich {value}-{max}€ pro Tour, abhängig von Dauer und Gruppengröße.',
        },
        {
          question: 'Wie flexibel ist das Hosting?',
          answer: 'Völlig flexibel! Du bestimmst, wann und wie oft du verfügbar bist.',
        },
      ],
    },
    resources: {
      title: 'Gastgeber-Ressourcen',
      subtitle: 'Alles, was du brauchst',
    },
    application: {
      title: 'Bewirb dich jetzt',
      subtitle: 'Starte deine Reise als lokaler Held',
    },
  },
  
  // Footer
  footer: {
    about: 'Über uns',
    contact: 'Kontakt',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    imprint: 'Impressum',
    accountDeletion: 'Konto löschen',
    copyright: '© {year} TravelHeroes. Alle Rechte vorbehalten.',
    description: 'Verbinde Touristen mit lokalen Helden in Wien',
    quickLinks: 'Schnelllinks',
    legal: 'Rechtliches',
  },

  // Account Deletion
  accountDeletion: {
    hero: {
      title: 'Kontolöschungsanfrage',
      description: 'Beantragen Sie die Löschung Ihres TravelHeroes-Kontos und der zugehörigen Daten in Übereinstimmung mit der DSGVO und den österreichischen Datenschutzgesetzen.',
    },
    steps: {
      title: 'So löschen Sie Ihr Konto',
      items: [
        {
          step: 'Anfrage einreichen',
          description: 'Geben Sie unten Ihre E-Mail-Adresse ein, um den Kontolöschungsprozess zu starten.',
        },
        {
          step: 'E-Mail-Verifizierung',
          description: 'Sie erhalten eine E-Mail mit einem Bestätigungslink zur Verifizierung Ihrer Identität.',
        },
        {
          step: 'Bedenkzeit',
          description: 'Ihr Konto wird sofort deaktiviert. Sie haben 30 Tage Zeit, die Löschung zu widerrufen, falls Sie Ihre Meinung ändern.',
        },
        {
          step: 'Endgültige Löschung',
          description: 'Nach 30 Tagen werden Ihr Konto und Ihre persönlichen Daten endgültig aus unseren Systemen gelöscht.',
        },
      ],
    },
    dataInfo: {
      title: 'Welche Daten werden gelöscht',
      deleted: {
        title: 'Die folgenden Daten werden dauerhaft gelöscht:',
        items: [
          'Persönliche Informationen (Name, E-Mail, Telefonnummer)',
          'Kontoanmeldedaten und Login-Informationen',
          'Buchungshistorie und Reisepräferenzen',
          'Gespeicherte Angebote und Favoriten',
          'App-Nutzungsdaten und Einstellungen',
        ],
      },
      retained: {
        title: 'Datenaufbewahrung zur Einhaltung gesetzlicher Vorschriften:',
        description: 'Gemäß österreichischem Recht müssen bestimmte Finanz- und Transaktionsunterlagen aufbewahrt werden:',
        items: [
          'Finanztransaktionsunterlagen (7 Jahre Aufbewahrung gemäß österreichischem Steuerrecht)',
          'Rechnungs- und Zahlungsdokumentation (7 Jahre Aufbewahrung)',
          'Anonymisierte Analysedaten zur Plattformverbesserung',
        ],
      },
      gracePeriod: 'Bedenkzeit: Sie haben 30 Tage Zeit, die Löschungsanfrage zu widerrufen. Nach dieser Frist ist die Löschung endgültig und unwiderruflich.',
    },
    form: {
      title: 'Löschungsanfrage einreichen',
      emailLabel: 'Ihre E-Mail-Adresse',
      emailPlaceholder: 'Geben Sie Ihre Konto-E-Mail ein',
      emailHelp: 'Geben Sie die E-Mail-Adresse ein, die mit Ihrem TravelHeroes-Konto verknüpft ist.',
      error: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      submit: 'Kontolöschung beantragen',
      terms: 'Mit der Einreichung dieser Anfrage bestätigen Sie, dass Ihr Konto und Ihre persönlichen Daten nach der 30-tägigen Bedenkzeit endgültig gelöscht werden.',
    },
    success: {
      title: 'Anfrage erfolgreich eingereicht',
      description: 'Wir haben eine Verifizierungs-E-Mail an Ihre Adresse gesendet. Bitte überprüfen Sie Ihr Postfach und klicken Sie auf den Bestätigungslink, um mit der Kontolöschung fortzufahren.',
      newRequest: 'Weitere Anfrage einreichen',
    },
    contact: {
      title: 'Fragen zur Datenlöschung?',
      description: 'Bei Fragen zu Ihren Daten oder zum Löschungsprozess kontaktieren Sie unser Datenschutzteam:',
    },
  },

  // Contact Us
  contact: {
    hero: {
      title: 'Kontakt',
      description: 'Nehmen Sie Kontakt mit unserem Team auf. Wir sind hier, um bei Fragen oder Supportanfragen zu helfen.',
    },
    users: {
      title: 'Für Reisende & Nutzer',
      description: 'Haben Sie Fragen zur Nutzung von TravelHeroes? Benötigen Sie Hilfe mit Ihrem Konto oder Buchungen?',
      emailLabel: 'Support E-Mail',
      email: 'support@travelheroes.at',
      linksTitle: 'Hilfreiche Ressourcen',
      links: [
        { label: 'Nutzungsbedingungen', href: '/terms-of-service' },
        { label: 'Datenschutzrichtlinie', href: '/privacy-policy' },
        { label: 'Konto löschen', href: '/account-deletion' },
      ],
    },
    partners: {
      title: 'Für Geschäftspartner',
      description: 'Interessiert an einer Partnerschaft mit TravelHeroes? Haben Sie Fragen zu unserer Plattform?',
      emailLabel: 'Partner E-Mail',
      email: 'partner@travelheroes.at',
      ctaText: 'Haben Sie weitere Fragen zur Partnerschaft?',
      ctaButton: 'Partner-FAQ besuchen',
      faqLink: '/partner-success-center#faq',
    },
  },
} as const;

export type TranslationKey = typeof de;